export default __webpack_public_path__ + "static/media/manual15.30ec09d8.png";